import { api } from "./api";

export interface ExportOptions {
  entity: string;
  format: 'pdf' | 'excel';
  language?: string;
  filters?: Record<string, any>;
  columns?: string[];
  headers?: string[];
  title?: string;
  dataRows?: Record<string, any>[];
  subtitle?: string;
  filterSummary?: string[];
}

export const exportApi = api.injectEndpoints({
  endpoints: (build) => ({
    genericExportTable: build.mutation<Blob, ExportOptions>({
      query: (data) => ({
        url: `/GenericExport`,
        method: "POST",
        body: data,
        responseHandler: async (response) => response.blob(),
      }),
    }),
  }),
});

export const { useGenericExportTableMutation } = exportApi;
